module.exports = __webpack_public_path__ + "img/status_grid.33067c42.png";